//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    data: function data() {
        return {
            name: '',
            address: '',
            city: '',
            state: '',
            zip: '',
            status: null,
            industry: null,
            defaultgl: null,
            contract_type: null,
            tax_type: null,
            selected_properties: [],
            contract_expire: moment().format("YYYY-MM-DD"),
            insurance_expire: moment().format("YYYY-MM-DD"),
            contract_start: moment().format("YYYY-MM-DD"),
            insurance_start: moment().format("YYYY-MM-DD"),
            insurance_file: false,
            insurance_file_bool: false,
            tax_file: false,
            tax_file_bool: false,
            consolidate_payments: false,
            is_1099: true,
            is_employee: false,
            dateConfig: {
                dateFormat: 'Y-m-d'
            },
            properties: [],
            accounts: [],
            contacts: [{
                name: '',
                email: '',
                phone: '',
                title: '',
                id: null
            }],
            contract_notification: '',
            contract_renewal: false,
            contract_file_bool: false,
            active: true,
            all_property_vendor: true,
            error: {
                name: false,
                address: false,
                city: false,
                state: false,
                zip: false,
                is_error: false
            }
        };
    },
    mounted: function mounted() {
        var _this = this;

        var $el = this;

        Event.$on('add-vendor', function () {

            // reset component
            Object.assign(_this.$data, _this.$options.data());

            // assign vendor as all property vendor
            $el.all_property_vendor = true;

            axios.get('/prototype/properties/quick/lookup').then(function (response) {
                $el.properties = response.data.properties;
                $el.selected_properties = response.data.properties;
            });
            axios.post('/prototype/accounting/general-ledger/accounts/fetch').then(function (response) {
                $el.accounts = response.data;
            });

            $el.$children[0].$data.showModal = true;
        });
    },


    methods: {
        newContact: function newContact() {
            this.contacts.push({
                name: '',
                email: '',
                phone: '',
                title: '',
                id: null
            });
        },
        removeContact: function removeContact(idx) {
            this.contacts.splice(idx, 1);
        },
        close: function close() {
            Event.$emit('close-full-modal');
        },
        save: function save() {
            var _this2 = this;

            this.error = {
                name: false,
                address: false,
                city: false,
                state: false,
                zip: false,
                is_error: false
            };

            if (this.name == "") {
                this.error.name = true;
                this.error.is_error = true;
            }
            if (this.address == "") {
                this.error.address = true;
                this.error.is_error = true;
            }
            if (this.city == "") {
                this.error.city = true;
                this.error.is_error = true;
            }
            if (this.state == "") {
                this.error.state = true;
                this.error.is_error = true;
            }
            if (this.zip == "") {
                this.error.zip = true;
                this.error.is_error = true;
            }
            if (!this.error.is_error) {
                var form = document.querySelector('#add_vendor_form');
                var data = new FormData(form);

                // append vue data
                data.append('status', this.status);
                data.append('active', this.active);
                data.append('contacts', JSON.stringify(this.contacts));
                data.append('industry', this.industry);
                if (this.defaultgl) {
                    data.append('default_gl', this.defaultgl.id);
                }
                data.append('contract_type', this.contract);
                data.append('tax_type', this.tax_type);
                data.append('selected_properties', this.selectedPropertyIds);
                data.append('contract_type', this.contract_type);
                data.append('contract_expire', this.contract_expire);
                data.append('contract_start', this.contract_start);
                data.append('contract_renewal', this.contract_renewal);
                data.append('contract_notification', this.contract_notification);
                data.append('insurance_expire', this.insurance_expire);
                data.append('insurance_start', this.insurance_start);
                data.append('consolidate_payments', this.consolidate_payments);
                data.append('is_1099', this.is_1099);
                data.append('is_employee', this.is_employee);
                data.append('id', 0);
                data.append('all_property_vendor', this.all_property_vendor);

                axios.post('/prototype/vendors/store', data).then(function (response) {
                    console.log(response);
                    Event.$emit('close-full-modal');
                    _this2.$snotify.success('The vendor was added');
                    Event.$emit('load-vendor-list');
                });
            }
        },
        selectNone: function selectNone() {
            this.selected_properties = [];
        },
        selectAll: function selectAll() {

            var $el = this;
            var select = this.$refs.properties;

            select.options.forEach(function (option) {
                console.log(option);
                $el.selected_properties.push(option);
            });

            // bug caused by onAfterSelect
            select.open = false;
        }
    },

    computed: {
        canPostTo: function canPostTo() {
            return this.accounts.filter(function (account) {
                return account.can_post_to === 1;
            });
        },
        accountNames: function accountNames() {
            return this.canPostTo.map(function (account) {
                return { id: account.id, label: account.number + ' - ' + account.name };
            });
        },
        selectedPropertyIds: function selectedPropertyIds() {
            return this.selected_properties.map(function (property) {
                return property.id;
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/vendors/AddVendor.vue
// module id = jKnE
// module chunks = 0 1